<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-dialog :persistent="true" v-model="show" max-width="800">
        <v-card>
          <v-card-title class="info white--text headline">{{
            recordLabel
          }}</v-card-title>
          <slot name="content">
            <PC-Form class="pl-3 pr-3" :fields="inputFields" @save="save">
              <template v-slot:submit>
                <v-card-actions>
                  <slot name="actions">
                    <v-spacer />
                    <v-btn color="red darken-1" flat @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn color="blue" flat type="submit">Save</v-btn>
                  </slot>
                </v-card-actions>
              </template>
            </PC-Form>
          </slot>
        </v-card>
      </v-dialog>
      <slot name="button">
        <v-btn fab bottom right fixed color="green" dark @click="create">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </slot>
    </v-flex>
  </v-layout>
</template>

<script>
import PCForm from "@/components/PCForm";
export default {
  name: "ForstaDialog",
  components: { PCForm },
  props: ["showDialog", "type", "fields"],
  data() {
    return {
      recordLabel: this.type,
      inputFields: this.fields,
      show: this.showDialog,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    create() {
      this.$emit("create");
    },
    save() {
      this.$emit("save", { create: this.newRecord });
    },
  },
  watch: {
    showDialog(newVal) {
      this.show = newVal;
    },
    fields(newVal) {
      this.inputFields = newVal;
    },
  },
};
</script>
